import { useCallback, useState } from "react";

function useSkipAddUser() {
  const [unSavedUserData, setUnsavedUserData] = useState([]);
  const [unSavedUserError, setUnsavedUserError] = useState([]);

  const byValidUser = useCallback(
    ({ valid }, index) => {
      return valid && !unSavedUserError?.[index];
    },
    [unSavedUserError]
  );

  return {
    setUnsavedUserData: setUnsavedUserData,
    setUnsavedUserError: setUnsavedUserError,
    shouldShowSkipConfirmation: useCallback(() => {
      return unSavedUserData.filter(byValidUser)?.length > 0;
    }, [unSavedUserData, byValidUser]),
    getValidUser: useCallback(() => {
      return unSavedUserData.filter(byValidUser).map(({ valid, ...props }) => {
        return { ...props, inviteNow: false };
      });
    }, [unSavedUserData, byValidUser]),
  };
}

export default useSkipAddUser;
